const TmpL012 = (page) => {
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: page.mediaData || [],
    images: page.imageData || [],
    materials: page.materialsData || [],
    eMentor: eMentors,
    focusPoints: page.focusPointsData || []
  };

  return { modifiedPage, metadata };
};

export default TmpL012;
